import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Navbar from "../component/NavBar";
import OrderSummary from "./OrderSummary";
import Footer from "../component/Footer";
import { CreateOrder, VerifyOrder } from "../Api/services/orderServices";
import { GetAllCartItems } from "../Api/services/CartServices";
import toast, { Toaster } from "react-hot-toast";

const CheckOut = () => {
    const navigate = useNavigate();
    const [cartItems, setCartItems] = useState([]);
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        country: "",
        state: "",
        city: "",
        pinCode: "",
        streetAddress: "",
    });
    
    const fetchCartItems = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await GetAllCartItems(token);
            if (response.status === 200) {
                setCartItems(response.data.cartItems);
            }
        } catch (error) {
            console.error("Error fetching cart items:", error);
            toast.error(error.response?.data?.message || "Failed to fetch cart items");
        }
    };

    useEffect(() => {
        fetchCartItems();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handlePayment = async () => {
        try {
            const token = localStorage.getItem("token");
            // Create order on the server
            const orderResponse = await CreateOrder(token);
            // console.log(orderResponse);
            if (orderResponse.success) {
                const options = {
                    key: "rzp_test_RVuOPmBoI6A3ZI",
                    amount: orderResponse.amount,
                    currency: orderResponse.currency,
                    name: "Kashika The shining one",
                    image: "https://res.cloudinary.com/rajnishdemo/image/upload/v1737289746/uploads/Black_logo_-_no_background_zzrime.png",
                    order_id: orderResponse.order_id,
                    handler: async function (response) {
                        // Prepare data for payment verification
                        try {
                            const verifyPayload = {
                                razorpay_order_id: response.razorpay_order_id,
                                razorpay_payment_id: response.razorpay_payment_id,
                                razorpay_signature: response.razorpay_signature,
                                customerName: `${formData.firstName} ${formData.lastName}`,
                                email: formData.email,
                                phoneNumber: formData.phone,
                                shippingAddress: {
                                    street: formData.streetAddress,
                                    city: formData.city,
                                    state: formData.state,
                                    pinCode: formData.pinCode,
                                    country: formData.country
                                },
                            };

                            const result = await VerifyOrder(token, verifyPayload);
                               
                            if (result.success) {
                                toast.success("Order placed successfully!");
                                navigate("/my-order");
                            }
                        } catch (err) {
                            console.error("Payment verification failed:", err);
                            toast.error("Payment verification failed");
                        }
                    },
                    prefill: {
                        name: `${formData.firstName} ${formData.lastName}`,
                        email: formData.email,
                        contact: formData.phone
                    },
                    theme: {
                        color: "#000000",
                        hide_topbar: true,
                        hide_footer: true,
                        hide_pay_button: true,
                    }
                };

                const paymentObject = new window.Razorpay(options);
                paymentObject.open();
            } else {
                toast.error("Failed to create order");
            }
        } catch (error) {
            console.error("Error initiating payment:", error);
            toast.error("Could not initiate payment. Please try again.");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!cartItems.length) {
            toast.error("Your cart is empty!");
            return;
        }
        handlePayment();
    };


    return (
        <>
            <Navbar />
            <Toaster />
            {cartItems.length === 0 ? (
                <div className="text-center py-12 min-h-[50vh]">
                    <p className="text-2xl text-gray-600 mb-4">Your cart is empty</p>
                    <Link to="/shop" className="inline-block px-6 py-3 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors">
                        Continue Shopping
                    </Link>
                </div>
            ) : (
                <>
                    <OrderSummary orderItems={cartItems} />
                    <form
                        className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-md"
                        onSubmit={handleSubmit}
                    >
                        <h2 className="text-lg font-bold mb-4">Billing Details</h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <input
                                type="text"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                placeholder="First Name"
                                className="border rounded-md p-2 w-full"
                                required
                            />
                            <input
                                type="text"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                placeholder="Last Name"
                                className="border rounded-md p-2 w-full"
                                required
                            />
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Email Address"
                                className="border rounded-md p-2 w-full"
                                required
                            />
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="Phone"
                                className="border rounded-md p-2 w-full"
                                required
                            />
                            <input
                                type="text"
                                name="state"
                                value={formData.state}
                                onChange={handleChange}
                                placeholder="State"
                                className="border rounded-md p-2 w-full"
                            />
                            <input
                                type="text"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                placeholder="Town/City"
                                className="border rounded-md p-2 w-full"
                                required
                            />
                            <input
                                type="text"
                                name="pinCode"
                                value={formData.pinCode}
                                onChange={handleChange}
                                placeholder="PIN Code"
                                className="border rounded-md p-2 w-full"
                                required
                            />
                            <input
                                type="text"
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                                placeholder="Country"
                                className="border rounded-md p-2 w-full"
                                required
                            />
                        </div>
                        <input
                            type="text"
                            name="streetAddress"
                            value={formData.streetAddress}
                            onChange={handleChange}
                            placeholder="Street Address"
                            className="border rounded-md p-2 w-full mt-4"
                            required
                        />
                        <button
                            type="submit"
                            className="mt-6 w-full bg-black text-white py-2 px-4 rounded hover:bg-gray-800"
                        >
                            Place Order and Pay
                        </button>
                    </form>
                </>
            )}
            <Footer />
        </>
    );
};

export default CheckOut;
